import { render, staticRenderFns } from "./ProjectViewTradesList.vue?vue&type=template&id=4ad8ff14&scoped=true&"
import script from "./ProjectViewTradesList.vue?vue&type=script&lang=ts&"
export * from "./ProjectViewTradesList.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectViewTradesList.vue?vue&type=style&index=0&id=4ad8ff14&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ad8ff14",
  null
  
)

export default component.exports